import styled from 'styled-components';

const PublicAboutMe = (props) => {
    const { academicTraining, workExperience } = props;

    return (
        <PublicAboutMeContainer>
            <Title>Formación y experiencia</Title>
            <Section>
                <Subtitle>Educación en otras instituciones</Subtitle>
                <Description>{academicTraining || '-'}</Description>
            </Section>
            <Section>
                <Subtitle>Experiencia laboral</Subtitle>
                <Description>{workExperience || '-'}</Description>
            </Section>
            {/* <Title>Intereses y motivaciones</Title>
            <Section>
                <Subtitle>Intereses</Subtitle>
            </Section> */}
        </PublicAboutMeContainer>
    );
};

export default PublicAboutMe;

const PublicAboutMeContainer = styled.div`
    display: flex;
    flex-direction: column;
    min-height: 100vh;
    box-sizing: border-box;
    justify-content: flex-start;
    padding: 2rem;
    background-color: #fefffe;
    border-radius: 20px;
    border: 1px solid #a8a8a8;
    gap: 1.5rem;
    width: 100%;
`;

const Title = styled.h2`
    font-size: 20px;
    font-weight: 600;
    color: #b31d15;
    line-height: 29px;
`;

const Section = styled.section`
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
    width: 100%;
    justify-content: flex-start;
`;

const Subtitle = styled.h3`
    font-size: 1rem;
    font-weight: 600;
    line-height: 137.5%;
    color: #000000;
    letter-spacing: 0.024px;
`;

const Description = styled.p`
    font-size: 1rem;
    color: #7f7f7f;
    padding: 8px;
`;
